(function () {
    'use strict';

    angular
        .module('blocks.notifications')
        .factory('notifier', notifier);

    notifier.$inject = ['$rootScope'];

    /* @ngInject */
    function notifier($rootScope) {
        var service = {
            subscribe: subscribe,
            notify: notify,
        };

        return service;
        /////////////////////

        function subscribe(eventName, scope, callback) {
            var handler = $rootScope.$on(eventName, callback);
            scope.$on('$destroy', handler);
        }

        function notify(eventName, data) {
            $rootScope.$emit(eventName, data);
        }
    }
}());
